// import firebase from 'firebase/app';
import 'firebase/firestore';
import  {initializeApp}  from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";
import firebase from './firebase';

const firebaseConfig = {
    // Your Firebase configuration
    apiKey: process.env.REACT_APP_FIREBAESE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBAESE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    databaseURL: process.env.REACT_APP_FIREBAESE_DB_URL,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBAESE_APP_ID
  };

const app=initializeApp(firebaseConfig)
export const db = getFirestore(app);



export const getDocumentFirebase=async()=>{
    const docRef = doc(db, "Market-share", "oeue56wGoKqUA5NpUrtL");
    const docSnap = await getDoc(docRef);

    // console.log(docSnap)
    try{
    if (docSnap.exists()) {
        // console.log(docSnap.data())
        return await docSnap.data();
      } else {
        // docSnap.data() will be undefined in this case
        //console.log("No such document!");
      }
    }
     catch(err){

     }
}



export const checkSuperAdmin=(email)=>{
    let data;
   data=getDocumentFirebase().then(data => {
    // d=data.users
    //console.log(data)
    //console.log(email)
    const user=data?.user?.filter(data=>{
        //console.log(data)
        if(data?.email===email){ 
            return true
        }
    })
    return user
  })

  .catch(error => {
    // Handle errors if needed
    console.error('Error fetching data:', error);
  });
   
//   //console.log(data)
  return data
}

export const checkAcessLevel=()=>{
    const data = getDocumentFirebase()
    //console.log(data)
    return data
}








